import { withHTMLComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';

const html = `
<upd-fa-icon name="check-circle" type="solid"></upd-fa-icon>
<upd-fa-icon name="plus-circle" type="light"></upd-fa-icon>
`;

const ATTRUBUTES = ['selected'];

class toggleSelection extends withHTMLComponent(styles, html)() {
  static observedAttributes = ATTRUBUTES;

  static reflectedAttributes = ATTRUBUTES.map(name => ({
    name,
    boolean: true,
  }));
}

customElements.define('upd-moveiq-toggle-selection', toggleSelection);
